const FORMULA_PREFIXES = ['=', '+', '-', '@', '\t', '\r', '\n'];

/** Prefix formula-triggering characters with a single quote so spreadsheet
 *  applications treat the cell as plain text instead of evaluating it as a
 *  formula. (CWE-1236) */
export function sanitizeCellValue(value: string): string {
	if (value.length > 0 && FORMULA_PREFIXES.includes(value[0])) {
		return "'" + value;
	}
	return value;
}

/** Sanitize all string values in a 2D data array in-place. */
export function sanitizeSheetData(data: unknown[][]): unknown[][] {
	return data.map((row) => row.map((cell) => (typeof cell === 'string' ? sanitizeCellValue(cell) : cell)));
}
